import {
  faPlay,
  faPlus,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faCheck,
  faDownload,
  faWrench,
  faTrash,
  faExclamation,
  faTimes,
  faClock,
  faSearch,
  faPaperPlane,
  faPhoneAlt,
  faCog,
  faUser,
  faFilePdf,
  faInfoCircle,
  faExternalLinkAlt,
  faPen,
  faPlusCircle,
  faGraduationCap,
  faBook,
  faProjectDiagram,
  faRulerCombined,
  faPause,
  faTimesCircle,
  faComments,
  faTools,
  faWifi,
  faStar,
  faBell,
  faRedo,
  faSortDown,
  faSortUp,
  faExclamationTriangle,
  faMapMarkerAlt,
  faFilter,
  faTachometerAlt,
  faStepBackward,
  faGlobeAmericas,
  faKey,
  faCodeBranch,
  faSync,
  faSpinner,
  faLock,
  faBolt
} from '@fortawesome/free-solid-svg-icons'

import {faThumbsUp as fasThumbsUp} from '@fortawesome/free-solid-svg-icons'
import {faThumbsDown as fasThumbsDown} from '@fortawesome/free-solid-svg-icons'
import {faQuestionCircle as fasQuestionCircle} from '@fortawesome/free-solid-svg-icons'

import {faCalendarAlt as farCalendarAlt} from '@fortawesome/free-regular-svg-icons'

import {
  faUserHardHat,
  faLockAlt,
  faShieldCheck,
  faCalendarExclamation,
  faBooks,
  faChartNetwork
} from '@fortawesome/pro-solid-svg-icons'

import {faThumbsUp as falThumbsUp} from '@fortawesome/pro-light-svg-icons'
import {faThumbsDown as falThumbsDown} from '@fortawesome/pro-light-svg-icons'
import {faCheck as falCheck} from '@fortawesome/pro-light-svg-icons'
import {faPlus as falPlus} from '@fortawesome/pro-light-svg-icons'
import {faTimes as falTimes} from '@fortawesome/pro-light-svg-icons'

import {
  faSignOutAlt,
  faWindowMinimize,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/pro-regular-svg-icons'

import type {IconDefinition} from '@fortawesome/fontawesome-svg-core'

const icons: Record<string, IconDefinition> = {
  faPlay,
  faPlus,
  falPlus,
  faCaretRight,
  faCaretLeft,
  faCaretUp,
  faCaretDown,
  faChevronLeft,
  faChevronRight,
  faCheck,
  falCheck,
  faDownload,
  faWrench,
  faTrash,
  faExclamation,
  faTimes,
  falTimes,
  faClock,
  faSearch,
  faSignOutAlt,
  faPaperPlane,
  faPhoneAlt,
  faCog,
  faUser,
  faFilePdf,
  faInfoCircle,
  faExternalLinkAlt,
  faPen,
  faGraduationCap,
  faBook,
  faBooks,
  faProjectDiagram,
  faUserHardHat,
  faRulerCombined,
  faPause,
  faTimesCircle,
  falThumbsUp,
  falThumbsDown,
  fasThumbsUp,
  fasThumbsDown,
  faComments,
  faTools,
  faWifi,
  faStar,
  faBell,
  faRedo,
  faSortDown,
  faSortUp,
  faSync,
  faWindowMinimize,
  faExclamationTriangle,
  faLockAlt,
  faShieldCheck,
  faMapMarkerAlt,
  faPlusCircle,
  faCalendarExclamation,
  farCalendarAlt,
  faFilter,
  faTachometerAlt,
  faChartNetwork,
  faStepBackward,
  fasQuestionCircle,
  faGlobeAmericas,
  faKey,
  faCodeBranch,
  faSpinner,
  faLock,
  faBolt
}

export default icons
